import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  enumEntries20mr21zbe3az4 as enumEntries,
  Unit_instance104q5opgivhr8 as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IPlanFeatureAccessor, 'IPlanFeatureAccessor');
initMetadataForClass(PlanFeature, 'PlanFeature', VOID, Enum);
//endregion
function IPlanFeatureAccessor() {
}
var PlanFeature_EMPLOYEE_TRAINING_instance;
function values() {
  return [PlanFeature_EMPLOYEE_TRAINING_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var PlanFeature_entriesInitialized;
function PlanFeature_initEntries() {
  if (PlanFeature_entriesInitialized)
    return Unit_instance;
  PlanFeature_entriesInitialized = true;
  PlanFeature_EMPLOYEE_TRAINING_instance = new PlanFeature('EMPLOYEE_TRAINING', 0, 'feat_employee_training');
}
var $ENTRIES;
function PlanFeature(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.v37_1 = value;
}
function PlanFeature_EMPLOYEE_TRAINING_getInstance() {
  PlanFeature_initEntries();
  return PlanFeature_EMPLOYEE_TRAINING_instance;
}
//region block: exports
export {
  IPlanFeatureAccessor as IPlanFeatureAccessor1c22ybcggkrw,
  get_entries as get_entriesvfuvsm248cwl,
};
//endregion

